<template>
  <main class="flex-1 overflow-y-auto bg-gray-50 p-6">
    <div class="max-w-7xl mx-auto">
      <!-- Dashboard Cards -->
      <div
        class="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-6 mb-8"
      >
        <DashboardCards
          v-for="(card, index) in stats.filter(
            (c) => c.label !== 'Active Classes',
          )"
          :key="index"
          :icon="card.icon"
          :label="card.label"
          :value="card.value"
          :bgColor="card.bgColor"
          :iconColor="card.iconColor"
          class="block"
        />
      </div>

      <!-- Quick Actions + Upcoming Events -->
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8">
        <QuickActions />
        <UpcomingEvents />
      </div>

      <!-- Announcements -->
      <div class="grid grid-cols-1 gap-6">
        <Announcements />
      </div>
    </div>

    <ChatBot />
  </main>
</template>

<script setup>
  import { computed } from "vue";
  import { useStore } from "vuex";
  import { Users, UserCheck, ClipboardCheck, BookOpen } from "lucide-vue-next";

  import DashboardCards from "@/components/Home/DashboardCards.vue";
  import QuickActions from "@/components/Home/QuickActions.vue";
  import Announcements from "@/components/Home/Announcements.vue";
  import UpcomingEvents from "@/components/Home/UpcomingEvents.vue";
  import ChatBot from "@/components/AI-ChatBot.vue";

  const store = useStore();

  const TotalTeachers = computed(() => store.getters.getTotalTeachers);
  const TotalClasses = computed(() => store.getters.totalClasses);

  const todaysAttendance = computed(
    () => store.state.todaysAttendancePercentage || "0%",
  );

  const TotalStudents = computed(() => store.getters.getTotalStudents);

  const UserRole = computed(() => store.getters.getUserRole);

  // ✅ Dashboard Cards
  const stats = computed(() => {
    const cards = [
      {
        icon: Users,
        label: "Total Students",
        value: TotalStudents.value,
        bgColor: "bg-blue-100",
        iconColor: "text-blue-600",
      },
      {
        icon: UserCheck,
        label: "Teaching Staff",
        value: TotalTeachers.value,
        bgColor: "bg-blue-100",
        iconColor: "text-blue-600",
        roleRestricted: "teacher",
      },
      {
        icon: BookOpen,
        label: "Active Classes",
        value: TotalClasses.value,
        bgColor: "bg-purple-100",
        iconColor: "text-purple-600",
      },
      {
        icon: UserCheck,
        label: "Present Today (Students)",
        value: todaysAttendance.value.presentToday || "0",
        bgColor: "bg-green-100",
        iconColor: "text-green-600",
      },
      {
        icon: ClipboardCheck,
        label: "Attendance Today",
        value: todaysAttendance.value.attendancePercentage,
        bgColor: "bg-orange-100",
        iconColor: "text-orange-600",
        mobileOnly: true,
      },
    ];

    return cards.filter((c) => c.roleRestricted !== UserRole.value);
  });
</script>
